import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TConnectionResult = 'success' | 'error' | 'none'

export type TSetConnectionResult = IAction<ETicketPayment.SET_CONNECTION_RESULT, TConnectionResult>

const setConnectionResult = (result: TConnectionResult): TSetConnectionResult => ({
    type: ETicketPayment.SET_CONNECTION_RESULT,
    payload: result,
});

export default setConnectionResult;
